import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import dayjs from 'dayjs'

// 简单的加密解密函数 - 支持Unicode字符
function simpleEncrypt (text) {
  try {
    const secretKey = 'your-secret-key-2024'
    let encrypted = ''
    for (let i = 0; i < text.length; i++) {
      encrypted += String.fromCharCode(text.charCodeAt(i) ^ secretKey.charCodeAt(i % secretKey.length))
    }
    // 使用 encodeURIComponent + btoa 来处理Unicode字符
    return btoa(encodeURIComponent(encrypted))
  } catch (e) {
    console.error('Encryption error:', e)
    return btoa(encodeURIComponent(text)) // 如果加密失败，至少进行base64编码
  }
}

function simpleDecrypt (encryptedText) {
  try {
    const secretKey = 'your-secret-key-2024'
    // 先解码base64，再解码URI组件
    const text = decodeURIComponent(atob(encryptedText))
    let decrypted = ''
    for (let i = 0; i < text.length; i++) {
      decrypted += String.fromCharCode(text.charCodeAt(i) ^ secretKey.charCodeAt(i % secretKey.length))
    }
    return decrypted
  } catch (e) {
    console.error('Decryption error:', e)
    try {
      // 如果解密失败，尝试直接解码base64
      return decodeURIComponent(atob(encryptedText))
    } catch (e2) {
      return null
    }
  }
}

const vuexLC = new VuexPersist({
  storage: window.localStorage,
  // 只持久化部分敏感度较低的状态
  reducer: (state) => ({
    userInfo: state.userInfo,
    companyInfo: state.companyInfo,
    userType: state.userType,
    token: state.token,
    isLogin: state.isLogin,
    currency: state.currency,
    lang: state.lang,
    metaInfo: state.metaInfo
    // 不持久化订单数据，防止敏感信息长期存储
  })
})
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    metaInfo: {},
    userInfo: {
      id: '',
      trueName: '匿名',
      mobile: '',
      userName: '',
      nickName: '',
      jifen: '',
      avatarUrl: '',
      email: ''
    },
    companyInfo: {
      currency: 'HKD',
      email: '',
      id: '',
      userName: '',
      linkSerial: '',
      mobile: '',
      trueName: '',
      type: ''
    },
    userType: 'B2C',
    token: {
      val: '',
      exp: 0
    },
    isLogin: false,
    currency: 'HKD',
    lang: 'zhCN',
    // 新增订单数据状态
    orderData: {
      // 套票基本信息
      packageBasicInfo: {},
      // 酒店信息
      packageHotelInfo: [],
      // 票券信息
      packageTicketInfo: [],
      // 附加产品信息
      addonProducts: [],
      // 非系统产品信息
      notXtProduct: [],
      // 价格相关信息
      priceInfo: {
        totalMoney: '',
        yhPrice: 0,
        sjPrice: '',
        bcPrice: '',
        supCurrency: 'HKD'
      },
      // 预订信息
      bookingInfo: {
        packageId: '',
        adult: 0,
        child: 0,
        roomNum: 1,
        checkInDate: '',
        checkOutDate: '',
        dataSource: '',
        num: 1
      },
      // 其他信息
      otherInfo: {
        tpName: '',
        addonName: '',
        ebkOption: '',
        returnState: null
      }
    }
  },
  mutations: {
    CHANGE_META_INFO (state, metaInfo) {
      state.metaInfo = metaInfo
    },
    setTureName (state, trueName) {
      state.userInfo.trueName = trueName
    },
    setMobile (state, mobile) {
      state.userInfo.mobile = mobile
    },
    setEmail (state, email) {
      state.userInfo.email = email
    },
    setUserInfo (state, userInfo) {
      if (!userInfo.trueName || userInfo.trueName === '') userInfo.trueName = userInfo.nickName
      if (!userInfo.trueName || userInfo.trueName === '') userInfo.trueName = '匿名'
      state.userInfo = userInfo
      state.isLogin = true
    },
    setCompanyInfo (state, companyInfo) {
      state.companyInfo = companyInfo
    },
    delUserInfo (state) {
      state.companyInfo = {
        currency: 'HKD',
        email: '',
        id: '',
        userName: '',
        linkSerial: '',
        mobile: '',
        trueName: '',
        type: ''
      }
      state.userInfo = {
        id: '',
        trueName: '匿名',
        userName: '',
        mobile: '',
        nickName: '',
        jifen: '',
        avatarUrl: '',
        email: ''
      }
      state.token = {
        val: '',
        exp: 0
      }
      state.isLogin = false
      state.userType = 'B2C'
    },
    setCurrency (state, currency) {
      state.currency = currency
    },
    setLang (state, lang) {
      state.lang = lang
    },
    setToken (state, token) {
      state.token = token
    },
    setUserType (state, type) {
      state.userType = type
    },
    // 新增订单数据相关mutations
    SET_ORDER_DATA (state, orderData) {
      state.orderData = { ...state.orderData, ...orderData }
    },
    SET_PACKAGE_INFO (state, packageInfo) {
      state.orderData.packageBasicInfo = packageInfo
    },
    SET_HOTEL_INFO (state, hotelInfo) {
      state.orderData.packageHotelInfo = hotelInfo
    },
    SET_TICKET_INFO (state, ticketInfo) {
      state.orderData.packageTicketInfo = ticketInfo
    },
    SET_ADDON_PRODUCTS (state, addonProducts) {
      state.orderData.addonProducts = addonProducts
    },
    SET_PRICE_INFO (state, priceInfo) {
      state.orderData.priceInfo = { ...state.orderData.priceInfo, ...priceInfo }
    },
    SET_BOOKING_INFO (state, bookingInfo) {
      state.orderData.bookingInfo = { ...state.orderData.bookingInfo, ...bookingInfo }
    },
    SET_OTHER_INFO (state, otherInfo) {
      state.orderData.otherInfo = { ...state.orderData.otherInfo, ...otherInfo }
    },
    CLEAR_ORDER_DATA (state) {
      state.orderData = {
        packageBasicInfo: {},
        packageHotelInfo: [],
        packageTicketInfo: [],
        addonProducts: [],
        notXtProduct: [],
        priceInfo: {
          totalMoney: '',
          yhPrice: 0,
          sjPrice: '',
          bcPrice: '',
          supCurrency: 'HKD'
        },
        bookingInfo: {
          packageId: '',
          adult: 0,
          child: 0,
          roomNum: 1,
          checkInDate: '',
          checkOutDate: '',
          dataSource: '',
          num: 1
        },
        otherInfo: {
          tpName: '',
          addonName: '',
          ebkOption: '',
          returnState: null
        }
      }
    }
  },
  getters: {
    VcompanyInfo: state => state.companyInfo,
    VuserInfo: state => state.userInfo,
    VisLogin: state => state.isLogin,
    Vcurrency: state => state.currency,
    Vlang: state => state.lang,
    VuserType: state => state.userType,
    Vtoken: state => {
      if (dayjs().unix() + 60 >= state.token.exp) {
        store.commit('delUserInfo')
        return ''
      } else {
        return state.token.val
      }
    },
    // 新增订单数据相关getters
    VorderData: state => state.orderData,
    VpackageInfo: state => state.orderData.packageBasicInfo,
    VhotelInfo: state => state.orderData.packageHotelInfo,
    VticketInfo: state => state.orderData.packageTicketInfo,
    VpriceInfo: state => state.orderData.priceInfo,
    VbookingInfo: state => state.orderData.bookingInfo
  },
  actions: {
    // 安全地设置订单数据
    setSecureOrderData ({ commit }, orderData) {
      // 在这里可以添加数据验证逻辑
      commit('SET_ORDER_DATA', orderData)
    },
    // 生成加密的传输token
    generateSecureToken ({ state }) {
      const orderData = state.orderData
      const tokenData = {
        timestamp: Date.now(),
        data: orderData
      }
      return simpleEncrypt(JSON.stringify(tokenData))
    },
    // 从加密token中恢复数据
    restoreFromSecureToken ({ commit }, token) {
      try {
        const decrypted = simpleDecrypt(token)
        if (!decrypted) {
          throw new Error('解密失败')
        }
        const tokenData = JSON.parse(decrypted)

        // 检查token时效性（例如30分钟）
        if (Date.now() - tokenData.timestamp > 30 * 60 * 1000) {
          throw new Error('Token已过期')
        }

        commit('SET_ORDER_DATA', tokenData.data)
        return true
      } catch (error) {
        console.error('Token恢复失败:', error)
        return false
      }
    }
  },
  plugins: [
    vuexLC.plugin
  ]
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js